import React from "react";
import Button from "../../shared/button";
import Chatbot from "../chatbot/chatbot";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react/dist/iconify.js";

const Pricingbanner = () => {
  const { t } = useTranslation();
  const pricingData = [
    {
      plan: t("home.pricing.basicPlan.title"),
      tagline: "Great for private individuals",
      price: t("home.pricing.basicPlan.price"),
      monthtxt: false,
      features: [
        t("home.pricing.planFeatures.one"),
        t("home.pricing.planFeatures.two"),
        t("home.pricing.planFeatures.three"),
        t("home.pricing.planFeatures.four"),
        t("home.pricing.planFeatures.five"),
        t("home.pricing.planFeatures.six"),
        t("home.pricing.planFeatures.seven"),
      ],
      isPopular: false,
      bgImg: "../../assets/images/home/basicCardBg.png",
      eclass: "",
    },
    {
      plan: t("home.pricing.premiumPlan.title"),
      tagline: "14 days free period",
      price: t("home.pricing.premiumPlan.price"),
      monthtxt: true,
      features: [
        t("home.pricing.planFeatures.one"),
        t("home.pricing.planFeatures.two"),
        t("home.pricing.planFeatures.three"),
        t("home.pricing.planFeatures.four"),
        t("home.pricing.planFeatures.five"),
        t("home.pricing.planFeatures.six"),
        t("home.pricing.planFeatures.seven"),
        t("home.pricing.planFeatures.eight"),
        t("home.pricing.planFeatures.nine"),
        t("home.pricing.planFeatures.ten"),
        t("home.pricing.planFeatures.eleven"),
        t("home.pricing.planFeatures.twelve"),
        t("home.pricing.planFeatures.thirteen"),
        t("home.pricing.planFeatures.fourteen"),
        t("home.pricing.planFeatures.fifteen"),
        t("home.pricing.planFeatures.sixteen"),
      ],
      isPopular: false,
      bgImg: "../../assets/images/home/pricing-back.png",
      eclass: "eclass",
    },
    {
      plan: t("home.pricing.exclusivePlan.title"),
      tagline: "14 days free period",
      price: t("home.pricing.exclusivePlan.price"),
      monthtxt: true,
      features: [
        t("home.pricing.planFeatures.two"),
        t("home.pricing.planFeatures.three"),
        t("home.pricing.planFeatures.four"),
        t("home.pricing.planFeatures.five"),
        t("home.pricing.planFeatures.six"),
        t("home.pricing.planFeatures.seven"),
        t("home.pricing.planFeatures.eight"),
        t("home.pricing.planFeatures.nine"),
        t("home.pricing.planFeatures.ten"),
        t("home.pricing.planFeatures.eleven"),
        t("home.pricing.planFeatures.twelve"),
        t("home.pricing.planFeatures.thirteen"),
        t("home.pricing.planFeatures.fourteen"),
        t("home.pricing.planFeatures.fifteen"),
        t("home.pricing.planFeatures.sixteen"),
        t("home.pricing.planFeatures.seventeen"),
        t("home.pricing.planFeatures.eighteen"),
      ],
      isPopular: false,
      bgImg: "../../assets/images/home/pricing-back.png",
      eclass: "eclass",
    },
  ];

  const featuresList = [
    t("home.pricing.planFeatures.one"),
    t("home.pricing.planFeatures.two"),
    t("home.pricing.planFeatures.three"),
    t("home.pricing.planFeatures.four"),
    t("home.pricing.planFeatures.five"),
    t("home.pricing.planFeatures.six"),
    t("home.pricing.planFeatures.seven"),
    t("home.pricing.planFeatures.eight"),
    t("home.pricing.planFeatures.nine"),
    t("home.pricing.planFeatures.ten"),
    t("home.pricing.planFeatures.eleven"),
    t("home.pricing.planFeatures.twelve"),
    t("home.pricing.planFeatures.thirteen"),
    t("home.pricing.planFeatures.fourteen"),
    t("home.pricing.planFeatures.fifteen"),
    t("home.pricing.planFeatures.sixteen"),
    t("home.pricing.planFeatures.seventeen"),
    t("home.pricing.planFeatures.eighteen"),
  ];
  return (
    <>
      <div className="about-banner-main max-sm:pt-[97px] pt-[237px] relative pb-[100px] w-100 bg-white min-h-[100vh] rounded-tl-none rounded-tr-none rounded-bl-[38px] rounded-br-[38px]">
        <div className="banner-inner back-banner max-xxxl:h-[100vh] h-[calc(100vh_-_250px)] w-[100%] absolute top-0 z-[1] right-0"></div>
        <div className="content z-[2] relative  max-xxxl:max-w-[90%] max-w-[80%] m-auto flex flex-col justify-center items-center">
          <div>
            <h1 className="text-center text-white font-sora tracking-[-2px] leading-[90px]">
              {t("pricing.title")}
            </h1>
            <h1 className="text-center gradient-text font-sora tracking-[-2px] leading-[90px] max-sm:leading-[65px]">
              {t("pricing.subtitle")}
            </h1>
          </div>

          <div className="flex relative h-fit mt-[45px] w-full">
            <div className="flex relative z-[2] pl-[46px] pr-[60px]  max-sm:overflow-x-auto max-sm:pl-[20px] max-sm:pr-[20px] py-[48px] w-full  drop-shadow-md shadow-lg bg-white bg-opacity-60 backdrop-blur-3xl rounded-[38px] overflow-hidden">
              <table className="w-full border-collapse text-left ">
                <thead>
                  <tr>
                    <th className="border-b-2 border-b-black border-solid">
                      <h3 className="mb-[20px] mt-3 leading-[40px] tracking-[-1.2px] font-sora">
                        {t("home.pricing.planFeatures.title")}
                      </h3>
                    </th>
                    {pricingData.map((plan, index) => (
                      <th
                        key={index}
                        className="border-b-2 border-b-black border-solid "
                      >
                        <h4 className=" mb-[20px] text-center small mt-3 leading-[40px] tracking-[-1.2px] font-sora">
                          {plan.plan}
                        </h4>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {featuresList.map((feature, index) => (
                    <tr key={index}>
                      <td
                        className={`border-b-2 border-b-gray-300 border-solid font-manrope medium py-[5px] w-full tex-grey leading-[30px] font-medium`}
                      >
                        {feature}
                      </td>
                      {pricingData.map((plan, planIndex) => (
                        <td
                          key={planIndex}
                          className={`border-b-2 border-b-gray-300 border-solid font-manrope medium py-[5px] tex-grey leading-[30px] font-medium`}
                        >
                          {/* Show special "(7 days)" and "(3 days)" for the first feature */}
                          {feature === t("home.pricing.planFeatures.one") &&
                          planIndex === 0 ? (
                            <div className="flex items-center gap-[1px]">
                              <Icon
                                icon="mdi:tick"
                                color="black"
                                className="m-auto"
                              />
                              <p className="ml-[-60px]">(7 days)</p>
                            </div>
                          ) : feature === t("home.pricing.planFeatures.one") &&
                            planIndex === 1 ? (
                            <div className="flex items-center gap-[1px]">
                              <Icon
                                icon="mdi:tick"
                                color="black"
                                className="m-auto"
                              />
                              <p className="ml-[-60px]">(3 days)</p>
                            </div>
                          ) : plan.features.includes(feature) ? (
                            <Icon
                              icon="mdi:tick"
                              color="black"
                              className="m-auto"
                            />
                          ) : (
                            <Icon
                              icon="charm:cross"
                              color="black"
                              className="m-auto"
                            />
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
                  {/* Pricing Row */}
                  <tr>
                    <td>
                      <h4 className="small font-semibold leading-[60px] font-sora">
                        {t("home.pricing.price")}
                      </h4>
                    </td>
                    {pricingData.map((plan, index) => (
                      <td
                        key={index}
                        className="border-b border-gray-300 p-4 text-center font-semibold"
                      >
                        <div className="flex flex-col items-center">
                          <div>
                            <span className="text-l font-sora">
                              {plan.price}
                            </span>
                            {plan.monthtxt && (
                              <span className="text-sm font-sora"></span>
                            )}
                          </div>

                          <Button
                            text="Get Started"
                            className="button btn-primary mt-2"
                            height={40}
                            width={140}
                          />
                        </div>
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
            <img
              src="../../assets/images/home/pricing-back.png"
              alt="bg"
              className="absolute w-full h-full max-w-[60%] right-[10px] z-[1] max-sm:right-[20px]"
            />
          </div>
          {/* <div className="pricing-cards flex flex-col md:flex-row lg:flex-row gap-[42px] mt-[52px] w-full">
            <div className="basic-card max-w-full md:max-w-[40%] lg:max-w-[40%] w-full rounded-[25px] p-card max-sm:pl-[20px] max-sm:pr-[20px] flex flex-col justify-between gap-[24px] shadow-md">
              <div className="flex flex-col gap-[24px]">
                <div className="card-top">
                  <h4 className="font-sora leading-[40px] tracking-[-1.2px] heading-color">
                    {t("pricing.basic.title")}
                  </h4>
                  <p className="font-semibold tex-grey  mt-[14px] medium tracking-[-0.48px]">
                    {t("pricing.basic.subtitle")}
                  </p>
                </div>
                <div className="card-middle-content flex flex-col gap-[10px]">
                  <div>
                    <p className="font-semibold tex-grey leading-[30px]  medium ">
                      {t("pricing.basic.one.title")}
                    </p>
                    <p className=" tex-grey leading-[30px]  medium ">
                      {t("pricing.basic.one.desc")}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold tex-grey leading-[30px]  medium ">
                      {t("pricing.basic.two.title")}
                    </p>
                    <p className=" tex-grey leading-[30px]  medium ">
                      {t("pricing.basic.two.desc")}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold tex-grey leading-[30px]  medium ">
                      {t("pricing.basic.three.title")}
                    </p>
                    <p className=" tex-grey leading-[30px]  medium ">
                      {t("pricing.basic.three.desc")}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold tex-grey leading-[30px]  medium ">
                      {t("pricing.basic.four.title")}
                    </p>
                    <p className=" tex-grey leading-[30px]  medium ">
                      {t("pricing.basic.four.desc")}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold tex-grey leading-[30px]  medium ">
                      {t("pricing.basic.five.title")}
                    </p>
                    <p className=" tex-grey leading-[30px]  medium ">
                      {t("pricing.basic.five.desc")}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold tex-grey leading-[30px]  medium ">
                      {t("pricing.basic.six.title")}
                    </p>
                    <p className=" tex-grey leading-[30px]  medium ">
                      {t("pricing.basic.six.desc")}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold tex-grey leading-[30px]  medium ">
                      {t("pricing.basic.seven.title")}
                    </p>
                    <p className=" tex-grey leading-[30px]  medium ">
                      {t("pricing.basic.seven.desc")}
                    </p>
                  </div>
                </div>
              </div>

              <div className="card-bottom">
                <h2 className="font-semibold leading-[60px] font-sora">
                  {t("pricing.basic.price")}
                </h2>
                <Button
                  text={t("pricing.basic.button")}
                  className="button btn-primary mt-[20px]"
                  height={50}
                  width={175}
                />
              </div>
            </div>
            <div className="basic-card max-w-full md:max-w-[60%] lg:max-w-[60%] w-full rounded-[25px] p-card max-sm:pl-[20px] max-sm:pr-[20px] flex flex-col justify-between gap-[24px] shadow-md">
              <div className="flex flex-col gap-[24px]">
                <div className="card-top">
                  <h4 className="font-sora leading-[40px] tracking-[-1.2px] heading-color">
                    {t("pricing.premium.title")}
                  </h4>
                  <p className="font-semibold tex-grey  mt-[14px] medium tracking-[-0.48px]">
                    {t("pricing.premium.subtitle")}
                  </p>
                </div>
                <div className="card-middle-content flex flex-col gap-[10px]">
                  <div>
                    <p className="font-semibold tex-grey leading-[30px]  medium ">
                      {t("pricing.premium.one.title")}
                    </p>
                    <p className=" tex-grey leading-[30px]  medium ">
                      {t("pricing.premium.one.desc")}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold tex-grey leading-[30px]  medium ">
                      {t("pricing.premium.two.title")}
                    </p>
                    <p className=" tex-grey leading-[30px]  medium ">
                      {t("pricing.premium.two.desc")}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold tex-grey leading-[30px]  medium ">
                      {t("pricing.premium.three.title")}
                    </p>
                    <p className=" tex-grey leading-[30px]  medium ">
                      {t("pricing.premium.three.desc")}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold tex-grey leading-[30px]  medium ">
                      {t("pricing.premium.four.title")}
                    </p>
                    <p className=" tex-grey leading-[30px]  medium ">
                      {t("pricing.premium.four.desc")}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold tex-grey leading-[30px]  medium ">
                      {t("pricing.premium.five.title")}
                    </p>
                    <p className=" tex-grey leading-[30px]  medium ">
                      {t("pricing.premium.five.desc")}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold tex-grey leading-[30px]  medium ">
                      {t("pricing.premium.six.title")}
                    </p>
                    <p className=" tex-grey leading-[30px]  medium ">
                      {t("pricing.premium.six.desc")}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold tex-grey leading-[30px]  medium ">
                      {t("pricing.premium.seven.title")}
                    </p>
                    <p className=" tex-grey leading-[30px]  medium ">
                      {t("pricing.premium.seven.desc")}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold tex-grey leading-[30px]  medium ">
                      {t("pricing.premium.eight.title")}
                    </p>
                    <p className=" tex-grey leading-[30px]  medium ">
                      {t("pricing.premium.eight.desc")}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold tex-grey leading-[30px]  medium ">
                      {t("pricing.premium.nine.title")}
                    </p>
                    <p className=" tex-grey leading-[30px]  medium ">
                      {t("pricing.premium.nine.desc")}
                    </p>
                  </div>
                </div>
              </div>

              <div className="card-bottom">
                <div className="flex items-end">
                  <h2 className="font-semibold leading-[60px] font-sora">
                    {t("pricing.premium.price")}
                  </h2>
                  <h6 className="font-semibold leading-[20px] pb-[6px] font-sora">
                    {t("pricing.premium.priceSuffix")}
                  </h6>
                </div>
                <Button
                  text={t("pricing.premium.button")}
                  className="button btn-primary mt-[20px]"
                  height={50}
                  width={175}
                />
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <Chatbot />
    </>
  );
};

export default Pricingbanner;
